// extracted by mini-css-extract-plugin
export default {"heading":"Products_heading__IP-iO","name":"Products_name__xA-z+","subcontent":"Products_subcontent__XUFli"};